<template>
  <div :class="[checked ? 'text-white bg-info' : '']" class="card">
    <div class="custom-control custom-radio py-2 pl-5">
      <input
        :id="id"
        :type="type"
        :value="inputValue"
        :checked="checked"
        class="custom-control-input"
        @change="$emit('input', inputValue)"
      />
      <label :for="id" class="custom-control-label">
        <slot />
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CheckboxCard',
  props: {
    value: {
      type: [String, Number],
      required: false,
      default: null,
    },
    type: {
      type: [String, Number],
      required: true,
    },
    inputValue: {
      type: [String, Number],
      required: true,
    },
  },
  computed: {
    id() {
      return `checkbox-card-${this.inputValue}`
    },
    checked() {
      return this.value === this.inputValue
    },
  },
}
</script>
